import BaseComponent from '@/components/base';
import { getStyle } from '@/components/media-component/style';
import { FontStyle } from '@/components/style';

export default class MediaComponent extends BaseComponent {
  render() {
    return `
      ${FontStyle}
      ${this.style}
      ${
        this.displayMediaOnly
          ? this.mediaElement
          : `<div class="main-wrapper">
          <div>
            ${this.mediaElement}
          </div>
          <div class="text-container">
            <div class="header">
              <div class="eyebrow body-font-4">${this.eyebrow}</div>
              <div class="title title-font-3">
                ${this.title}
              </div>
            </div>
              <div class="description body-font-1">${this.description}</div>
          </div>
        </div>`
      }`;
  }

  get backgroundColor() {
    return this.getAttribute('background-color');
  }

  get eyebrow() {
    return this.getAttribute('eyebrow');
  }

  get title() {
    return this.getAttribute('title');
  }

  get description() {
    return this.getAttribute('description');
  }

  get isInvert() {
    return this.getAttribute('invert') === 'true';
  }

  get desktopDirection() {
    return this.isInvert ? 'row-reverse' : 'row';
  }

  get mediaSrc() {
    return this.isSmall && this.getAttribute('media-src-mobile')
      ? this.getAttribute('media-src-mobile')
      : this.getAttribute('media-src');
  }

  get mediaType() {
    return this.getAttribute('media-type');
  }

  get mediaCustomStyle() {
    return this.getAttribute('media-custom-style') || '';
  }

  get displayMediaOnly() {
    return (
      this.getAttribute('display-media-only') === 'true' ||
      this.getAttribute('display-media-only') === ''
    );
  }

  get isVideo() {
    return /^video\//.test(this.mediaType);
  }

  get mediaElement() {
    if (this.isVideo && this.isIOS()) {
      return `
        <video
          loop muted autoPlay playsInline
          class="${this.displayMediaOnly ? 'full-width' : ''}"
          style="${this.mediaCustomStyle}"
        >
          <source src="${this.mediaSrcIphone}" type="video/quicktime">
        </video>
      `;
    }

    if (this.isVideo) {
      return `
        <video
          loop muted autoPlay playsInline
          class="${this.displayMediaOnly ? 'full-width' : ''}"
          style="${this.mediaCustomStyle}"
        >
          <source src="${this.mediaSrc}" type="${this.mediaType}">
        </video>`;
    }

    return `<img
          class="${this.displayMediaOnly ? 'full-width' : ''}"
          src="${this.mediaSrc}"
          style="${this.mediaCustomStyle}"
        />`;
  }

  get style() {
    return getStyle(this.isSmall, this.backgroundColor, this.desktopDirection);
  }

  get mediaSrcIphone() {
    return this.getAttribute('media-src-iphone');
  }

  isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document)
    );
  }
}
